import constant from '../../mixins/const';
import axios from "axios";
import abi from "../../mixins/abi";

import _ from 'lodash';
const CryptoJS = require('crypto-js');
const bitcore = require('bitcore-lib');
// bitcoinjs
const bitcoin = require('bitcoinjs-lib');
const assert = require('assert');

const Tx = require('ethereumjs-tx').Transaction;
const BigNumber = require('bignumber.js');
// const Mnemonic = require('bitcore-mnemonic');
// // const ethers = require('ethers');
// const hdkey = require('ethereumjs-wallet/hdkey');
// const bip39 = require("bip39");

const ethereumJsWallet = require('ethereumjs-wallet');
const ethUtil = require('ethereumjs-util');
const Web3 = require('web3');

const rippleKP = require('ripple-keypairs');
const RippleAPI = require('ripple-lib').RippleAPI;

const settingStoreName = 'settings';
const currencyAccountStoreName = 'currencyAccounts';

const bitcoinHost = constant.blockchainHost.Bitcoin;
const ethereumHost = constant.blockchainHost.Ethereum;
const rippleHost = constant.blockchainHost.Ripple;

const web3 = new Web3(new Web3.providers.HttpProvider(ethereumHost));

const blockStreamApiPath = (constant.blockchainEnv == 'test')?'testnet/':'';

const elliptic = require("elliptic");
const Secp256k1 = elliptic.ec('secp256k1');


/**
 * vwIdb
 * accounts->import済みのアカウント情報を収納
 *
 * settings->optKeyによって収納する情報を分けている
 * ┗currentAccount=>loginId: string(現在選択中のアカウント)
 */
// interface generateKey {
//     mnemonic: any;
//     pin: string;
//     order: number;
//     display: boolean;
// }

import {currencyData,unconfirmedTxHistory,feeBase} from '@/mixins/interface';
import format from "@/mixins/format";

const state = {
    transferReady: null,
}

const getters = {
    getTransferReady(state: any) {
        return state.transferReady;
    },
}

const actions = {

    transferReady(store: any, payload: any) {
        return new Promise(async (resolve, reject) => {
            store.commit('transferReady', payload);
            resolve(true);
        });
    },

    getFeeBase(store: any, data: {platform: string, payload: any}) {
        const feeImport = async function(basePlatform: string, now: number) {
            let defaultData;
            if (basePlatform == 'Ether') {
                defaultData = {};
            } else {
                defaultData = 0;
            }
            // 2時間以上たっている場合
            let feeBase: feeBase = {
                basePlatform: basePlatform,
                data: defaultData,
                updatedAt: now
            };

            if (data.platform == 'Bitcoin') {
                const feeData = await axios.get('https://api.blockchain.info/mempool/fees')
                .catch((e:any) => {
                    console.log(e);
                    return feeBase;
                });
                console.log('fee response', feeData);
                feeBase.data = parseInt(feeData.data.regular);
            } else if (data.platform == 'Ether' || data.platform == 'ERC20') {
                // gasLimit 取得
                let gasLimit = await web3.eth.estimateGas({from: data.payload.from})
                .catch((e: any) => {
                    console.error(e);
                    return feeBase;
                });
                // estimateGasを実行した瞬間とトランザクションを送信する瞬間で変化が起きる可能性があるので若干の余裕を持たせると安心です。
                console.log('gas limit', gasLimit);
                feeBase.data.gasLimit = gasLimit + 10000;

                // gasPrice取得
                let gasPrice = await web3.eth.getGasPrice()
                .catch((e: any) => {
                    console.error(e);
                    return feeBase;
                });
                feeBase.data.gasPrice = parseInt(gasPrice); // +3000000余裕持たせる必要ある？

                // nonce取得
                const count = await web3.eth.getTransactionCount(data.payload.from)
                .catch((e: any) => {
                    console.error(e);
                    return feeBase;
                });
                // この場合、nonceはgetTransactionCountの値をそのまま入れれば良いですが、実際はトランザクション毎にインクリメントする必要がある値ですから、トランザクションを複数生成する際はその点注意が必要です。
                // 具体的には、複数のトランザクションを作成して、その後にsendするようなケースの場合に、nonceのインクリメントを忘れていて同一の値になっていると1つ目以降のトランザクションはエラーになってしまいます。
                feeBase.data.nonce = count;
            } else if (data.platform == 'Ripple') {
                const api = new RippleAPI({
                    server: rippleHost
                });
                await api.connect()
                .catch((e: any) => {
                    console.log('Rippleサーバーエラー', e);
                    return feeBase;
                });
                feeBase.data = await api.getFee();
                await api.disconnect();
            }
            if (feeBase.data == 0) {
                console.log('fee 0');
                return feeBase;
            } else{
                await store.dispatch('idbPut', {stateName: null, storeName: 'feeBases', data: feeBase}, {root: true});
                return feeBase;
            }
        }
        return new Promise(async (resolve, reject) => {
            const now = Date.now();
            const basePlatform = (data.platform == 'ERC20') ? 'Ether' : data.platform;
            console.log('now', now, basePlatform);
            const pastFeeBase: feeBase = await store.dispatch('idbSelect', {stateName: null, storeName: 'feeBases', keyValue: basePlatform}, {root: true});

            if (pastFeeBase) {
                console.log('get feeBase', pastFeeBase);
                // +2時間
                const pastFeeDatePlusHours = pastFeeBase.updatedAt + (1000 * 60 * 60 * 2);

                if (pastFeeDatePlusHours < now) {
                    resolve(await feeImport(basePlatform, now));
                } else {
                    resolve(pastFeeBase);
                }
            } else {
                console.warn('no feeBase')
                resolve(await feeImport(basePlatform, now));
            }
        });
    },

    getBitcoinFee(store: any, data: any) {
        return new Promise(async (resolve, reject) => {

            const amount = BigNumber(data.amount).times(100000000).toNumber(); // BTC->sat
            const perBytes = data.perBytes;
            const accountNumber = data.accountNumber;
            // amount > 0, accountNumberで支払い可能なAddressを検索
            // const btcAddresses = await store.dispatch('idbSelectAll', {stateName: null, storeName: 'btcAddress'}, {root: true});
            const search = {
                value: accountNumber
            }
            const btcAddresses = await store.dispatch('idbGetByIdx', {stateName: null, storeName: 'btcAddress', indexName: 'accountNumber', search: search}, {root: true});
            console.log('all data', btcAddresses);
            const payableAddresses = btcAddresses.filter((addrData: any) => {
                console.log('addrData', addrData);
                return parseFloat(addrData.amount) > 0;
            })
            console.log('payableAddresses', payableAddresses);
            let payableTotal = BigNumber(0);

            let indexInUse = 0; // どのアドレスまで利用するかのindex
            let fees = BigNumber(0);
            for (let i = 0; i < payableAddresses.length; i++) {
                // アドレスが持っている金額が支払額に到達するまで回す
                // アドレスが持っている金額をプラス
                payableTotal = payableTotal.plus(payableAddresses[i].amount);

                // ここまで算出したアドレスが支払える金額 > 支払額
                if (payableTotal.toNumber() > amount) {
                    // 同時に手数料計算
                    let input = i + 1;
                    const output = 1;
                    fees = BigNumber(input * 146 + output * 33 + 10).times(perBytes);//satoshi
                    // 送金額＋FEEが支払える額より低ければ確定
                    const paymentTotal = BigNumber(amount).plus(fees);
                    if (payableTotal.toNumber() > paymentTotal.toNumber()) {
                        break;
                    }
                }
            }
            // 5430が下限
            if (fees.toNumber() < 5430) {
                fees = BigNumber(5430);
            }

            resolve(fees.toNumber());
        });
    },

    transferConfirm(store: any, data: {platform: string, parameter: any}) {
        return new Promise(async (resolve, reject) => {
            let res: any = {};

            if (data.platform == 'Bitcoin') {
                const to = data.parameter.to;
                const amount = BigNumber(data.parameter.amount).times(100000000).toNumber(); // BTC->sat
                const fees = BigNumber(data.parameter.fees).times(100000000).toNumber(); // BTC->sat
                const accountNumber = data.parameter.accountNumber;
                const paymentTotal = BigNumber(amount).plus(fees).toNumber();// sat

                // amount > 0, accountNumberで支払い可能なAddressを検索
                // const btcAddresses = await store.dispatch('idbSelectAll', {stateName: null, storeName: 'btcAddress'}, {root: true});
                const search = {
                    value: accountNumber
                }
                const btcAddresses = await store.dispatch('idbGetByIdx', {stateName: null, storeName: 'btcAddress', indexName: 'accountNumber', search: search}, {root: true});
                console.log('all data', btcAddresses);
                const payableAddresses = btcAddresses.filter((addrData: any) => {
                    console.log('addrData', addrData);
                    return parseFloat(addrData.amount) > 0;
                })
                console.log('payableAddresses', payableAddresses);
                let payableTotal = BigNumber(0);
                let indexInUse = 0; // どのアドレスまで利用するかのindex
                for (let i = 0; i < payableAddresses.length; i++) {
                    // アドレスが持っている金額が支払額に到達するまで回す
                    // アドレスが持っている金額をプラス
                    payableTotal = payableTotal.plus(payableAddresses[i].amount);

                    // ここまで算出したアドレスが支払える金額 > 支払額
                    if (payableTotal.toNumber() >= paymentTotal) {
                        indexInUse = i + 1;
                        break;
                    }
                }

                res = {
                    payableAddresses: payableAddresses.slice(0, indexInUse),
                    to: to,
                    amount: amount,
                    fees: fees,
                }
            }
            else if (data.platform == 'Ether' || data.platform == 'ERC20') {
                // init
                res.from = data.parameter.from;
                if (data.platform == 'Ether') {
                    res.to = data.parameter.to;
                } else {
                    res.to = data.parameter.contractAddress;
                }
                res.gasLimit = data.parameter.gasLimit;
                res.gasPrice = data.parameter.gasPrice;
                res.tokenDecimals = data.parameter.tokenDecimals;
                res.nonce = data.parameter.nonce;
                let weiValue = 0; // 実際にトランザクションに利用される値(etherだとwei化された後の値)

                if (data.platform == 'Ether') {
                    res.value = data.parameter.amount;// ETH
                    // weiValue = web3.utils.toWei(res.value, 'ether');// wei
                    res.data = null;
                } else if (data.platform == 'ERC20') {
                    if (data.parameter.value > 0) res.value = data.parameter.value;
                    const contract = new web3.eth.Contract(abi.erc20Abi, data.parameter.contractAddress);
                    weiValue = BigNumber(data.parameter.amount).times(10 ** res.tokenDecimals).toFixed();
                    res.data = await contract.methods.transfer(data.parameter.to, weiValue).encodeABI();
                }
            }
            else if (data.platform == 'Ripple') {
                res = data.parameter;
            }
            resolve(res);
        });
    },

    transfer(store: any, data: any) {
        return new Promise(async (resolve, reject) => {
            try {
                /**
                 * パラメータ生成
                 */
                console.log('platform check', data.platform);
                switch (data.platform) {
                    case 'Bitcoin':
                        await store.dispatch('transferBitcoin', data);
                        break;
                    case 'Ether':
                    case 'ERC20':
                        await store.dispatch('transferEthereum', data);
                        break;
                    case 'Ripple':
                        await store.dispatch('transferRipple', data);
                        break;
                    default:
                        break;
                }
                console.log('送金成功!!!!!!!!!!!!!!!!!!!!!!')
                resolve(true);

            } catch (error) {
                console.log('error.name: ' + error.name)
                console.log('error.message: ' + error.message)
                reject(error);
            }
        });
    },

    transferBitcoin(store: any, data: any) {
        return new Promise(async (resolve,reject) => {
            try {
                const networkName = (constant.blockchainHost.Bitcoin == 'testnet') ? 'testnet' : 'bitcoin';
                const network = bitcoin.networks[networkName];

                console.log('get data for transaction bitcoin', data);
                const accountNumber = data.accountNumber;
                const name = data.name;
                const amount = BigNumber(data.amount).times(100000000);// btc->satoshi
                const fees = data.fees;// satoshi
                const pin = data.pin;
                const to = data.to;
                const payableAddresses = data.payableAddresses;
                // currencyDataからおつりアドレス取得
                const changeAddress = data.changeAddress;
                const changePrivIdx = data.changePrivIdx;

                console.log('payableAddresses', payableAddresses);

                // pinで復号したmasterPrivKeyとpathからxprivKey作成
                const encrypted = await store.dispatch('idbSelect', {
                    stateName: null,
                    storeName: 'settings',
                    keyValue: 'bhdk'
                }, {root: true});
                console.log(encrypted);
                const privString = await store.dispatch('accountModule/decryptWithPin', {
                    pin: pin,
                    encrypted: encrypted.optValue
                }, {root: true});
                console.log(privString);
                if (privString === '') {
                    throw Error('invalid pin')
                }
                const masterPriv = bitcore.HDPrivateKey(privString);
                console.log(masterPriv);

                /**
                 * Bitcoinjs transaction
                 */

                /**
                 * 入力やprivKeyなどtransactionに必要な情報を取得
                 * @param addressData
                 */
                const getBtcTxParams = function (addressData: any) {
                    function createPayment(_type: string, myKeys?: any[]): any {
                        const splitType = _type.split('-').reverse();
                        const isMultisig = splitType[0].slice(0, 4) === 'p2ms';
                        const keys = myKeys || [];
                        let m: number | undefined;
                        if (isMultisig) {
                            const match = splitType[0].match(/^p2ms\((\d+) of (\d+)\)$/);
                            m = parseInt(match![1], 10);
                            let n = parseInt(match![2], 10);
                            if (keys.length > 0 && keys.length !== n) {
                                throw new Error('Need n keys for multisig');
                            }
                            while (!myKeys && n > 1) {
                                keys.push(bitcoin.ECPair.makeRandom({network}));
                                n--;
                            }
                        }
                        if (!myKeys) keys.push(bitcoin.ECPair.makeRandom({network}));

                        let payment: any;
                        splitType.forEach(type => {
                            if (type.slice(0, 4) === 'p2ms') {
                                payment = bitcoin.payments.p2ms({
                                    m,
                                    pubkeys: keys.map(key => key.publicKey).sort((a, b) => a.compare(b)),
                                    network,
                                });
                            } else if (['p2sh', 'p2wsh'].indexOf(type) > -1) {
                                payment = (bitcoin.payments as any)[type]({
                                    redeem: payment,
                                    network,
                                });
                            } else {
                                payment = (bitcoin.payments as any)[type]({
                                    pubkey: keys[0].publicKey,
                                    network,
                                });
                            }
                        });

                        return {
                            payment,
                            keys,
                        };
                    }

                    function getWitnessUtxo(out: any): any {
                        delete out.address;
                        out.script = Buffer.from(out.script, 'hex');
                        return out;
                    }

                    async function getInputData(
                        tx: any,
                        payment: any,
                        isSegwit: boolean,
                        redeemType: string,
                    ): Promise<any> {
                        let mixin;
                        if (isSegwit) {
                            const urlTxWitness = `https://blockstream.info/${blockStreamApiPath}api/tx/${tx.txid}`;
                            // for segwit inputs, you only need the output script and value as an object.
                            const fullTx = await axios.get(urlTxWitness);
                            console.log('fullTx', fullTx.data);
                            const witnessUtxo = getWitnessUtxo(fullTx.data);
                            mixin = {witnessUtxo};
                        } else {
                            const urlTxNonWitness = `https://blockstream.info/${blockStreamApiPath}api/tx/${tx.txid}/hex`;

                            const fullTxHex = await axios.get(urlTxNonWitness);
                            console.log('fullTxHex', fullTxHex.data);
                            const nonWitnessUtxo = Buffer.from(fullTxHex.data, 'hex');
                            // const hex = new bitcoin.Transaction();
                            // const nonWitnessUtxo = Buffer.from(hex, 'hex')
                            console.log('nonWitnessUtxo', nonWitnessUtxo);
                            mixin = {nonWitnessUtxo};
                        }

                        const mixin2: any = {};
                        switch (redeemType) {
                            case 'p2sh':
                                mixin2.redeemScript = payment.redeem.output;
                                break;
                            case 'p2wsh':
                                mixin2.witnessScript = payment.redeem.output;
                                break;
                            case 'p2sh-p2wsh':
                                mixin2.witnessScript = payment.redeem.redeem.output;
                                mixin2.redeemScript = payment.redeem.output;
                                break;
                        }
                        return {
                            hash: tx.txid,
                            index: tx.vout,
                            ...mixin,
                            ...mixin2,
                        };
                    }

                    return new Promise(async (resolve, reject) => {
                        console.log('addessData', addressData);
                        const address = addressData.address;
                        const privIdx = addressData.privIdx;
                        const change = addressData.change;

                        const addressCreatedData = await store.dispatch('accountModule/createMultiSigAddress', {
                            masterPriv: masterPriv,
                            change: change,
                            accountNumber: accountNumber,
                            privIdx: privIdx,
                            platform: 'Bitcoin'
                        }, {root: true});

                        const privateKeys = addressCreatedData.privateKeys;
                        console.log('privateKeys', privateKeys);
                        // bitcoinjsのobject作成
                        let mykeys: any = [];
                        for (let i = 0; i < privateKeys.length; i++) {
                            console.log('priv', privateKeys[i]);
                            const wif = new bitcore.PrivateKey(privateKeys[i]).toWIF();
                            console.log('wif', wif);
                            mykeys.push(bitcoin.ECPair.fromWIF(wif, network));
                        }
                        console.log('mykeys', mykeys);
                        const p2sh = createPayment('p2sh-p2ms(2 of 2)', mykeys);

                        const publicKeys = addressCreatedData.publicKeys;
                        console.log('publicKeys', publicKeys)

                        // 利用するアドレスのUTXOを取得
                        const urlTx = `https://blockstream.info/${blockStreamApiPath}api/address/${address}/utxo`;
                        const txData = await axios.get(urlTx)

                        if (txData.data.length > 0) {
                            console.log('txData', txData);
                            const utxos: any = [];
                            let unspentValue = BigNumber(0);
                            for (let i in txData.data) { // UTXOでloop
                                const tx = txData.data[i];
                                // const urlRawTx = `https://blockstream.info/testnet/api/tx/${tx.txid}`;
                                // const rawTxCheck = await axios.get(urlRawTx);
                                // console.log('urlRawTx', rawTxCheck.data)

                                const inputData = await getInputData(tx, p2sh.payment, false, 'p2sh');
                                console.log('inputData', inputData);
                                {
                                    const {
                                        hash, // string of txid or Buffer of tx hash. (txid and hash are reverse order)
                                        index, // the output index of the txo you are spending
                                        nonWitnessUtxo, // the full previous transaction as a Buffer
                                        redeemScript
                                    } = inputData;
                                    assert.deepStrictEqual({hash, index, nonWitnessUtxo, redeemScript}, inputData);
                                }
                                utxos.push(_.cloneDeep(inputData));

                                unspentValue = BigNumber(unspentValue).plus(tx.value);
                            }

                            resolve({
                                myKeys: p2sh.keys, // 署名用秘密鍵データ buffer[]
                                publicKeys: publicKeys, // アドレス再生成用公開鍵データ
                                utxos: _.cloneDeep(utxos), // このアドレスのUTXOS
                                unspentValue: unspentValue.toNumber() // このアドレスの合計残高
                            });
                        } else {
                            console.error('no utxo')
                            reject('no utxo')
                        }
                    });
                }

                console.log('payableAddresses', payableAddresses);
                let psbt = new bitcoin.Psbt({network: network});
                let allInputs = BigNumber(0);
                // inputのセット
                let privateKeys = []; // sign用のprivateKey
                let inputIndex = 0;
                for (let i in payableAddresses) { // addressでloop
                    const btcParams: any = await getBtcTxParams(payableAddresses[i]);
                    console.log('getBtcParams success', btcParams);
                    for (let j = 0; j < btcParams.utxos.length; j++) {// addressのutxoでloop
                        console.log('addinput', btcParams.utxos[j]);
                        psbt = psbt.addInput(btcParams.utxos[j]);
                        privateKeys[inputIndex] = btcParams.myKeys; // 署名用秘密鍵をセット(utxoの数用意)
                        inputIndex++;
                    }
                    allInputs = BigNumber(allInputs).plus(btcParams.unspentValue);
                }
                console.log('forsign', privateKeys);
                console.log('amount', amount.toNumber())

                // 支払先、支払量のセット
                psbt = psbt.addOutput({
                    address: to,
                    value: amount.toNumber(),
                });
                // おつりのセット
                let changeAmount = 0;
                if (changeAddress) {
                    // changeAmount = unspentValue - paymentValue - fees
                    const changeAmountBigNumber = BigNumber(allInputs).minus(amount).minus(fees);
                    changeAmount = changeAmountBigNumber.toNumber();
                    if (changeAmount > 0) {
                        psbt = psbt.addOutput({
                            address: changeAddress,
                            value: changeAmount,
                        });
                    }
                } else {
                    throw Error('not set change address');
                }
                console.log('allInputs', allInputs.toNumber())
                console.log('allOutputs', (amount.plus(changeAmount)).toNumber())

                // 署名
                for (let i = 0; i < privateKeys.length; i++) { // utxos loop
                    console.log('mykeys' + i, privateKeys[i]);
                    for (let j = 0; j < privateKeys[i].length; j++) { // privateKey loop
                        console.log('mykeys' + i + '[' + j + ']', privateKeys[i][j]);
                        const privForSign = privateKeys[i][j];
                        psbt = psbt.signInput(i, privForSign);

                        assert.strictEqual(
                            psbt.validateSignaturesOfInput(i, privForSign.publicKey),
                            true,
                        );
                    }
                }
                psbt.finalizeAllInputs();

                const tx = psbt.extractTransaction();
                console.log('tx', tx);

                const serialized = tx.toHex();

                console.log('serialized', serialized);

                if (changeAmount > 0) {
                    // お釣りがあった場合
                    if (accountNumber === undefined || accountNumber === null || changePrivIdx === undefined || changePrivIdx === null) {
                        throw Error('change address make param error');
                    }
                    let newChangeAddressData: any = null;
                    if (changePrivIdx <= 30) {
                        // お釣りアドレス生成
                        newChangeAddressData = await store.dispatch('accountModule/createMultiSigAddress', {
                            masterPriv: masterPriv,
                            change: true,
                            accountNumber: accountNumber,
                            privIdx: changePrivIdx + 1,
                            platform: 'Bitcoin'
                        }, {root: true});
                        console.log('newchange', newChangeAddressData);
                        const checkAddressExists = await store.dispatch('idbSelect', {stateName: null, storeName: 'btcAddress', keyValue: [accountNumber, changePrivIdx+1, 1]}, {root: true});
                        if (checkAddressExists.length == 0) {
                            // 該当のお釣りアドレスがなかったら保存
                            const addrData = {
                                accountNumber: accountNumber,
                                privIdx: changePrivIdx+1, // このprivIdx*2-1,privIdx*2が使われる
                                change: 1,
                                address: newChangeAddressData.address,
                                amount: 0
                            };
                            await store.dispatch('idbPut', {stateName: null, storeName: 'btcAddress', data: addrData}, {root: true});
                        }
                    } else {
                        newChangeAddressData = await store.dispatch('idbSelect', {
                            stateName: null,
                            storeName: 'btcAddress',
                            keyValue: [accountNumber, 0, 1]
                        }, {root: true})
                    }

                    const accountData = {
                        name: name,
                        changePrivIdx: newChangeAddressData.privIdx,
                        changeAddress: newChangeAddressData.address
                    }
                    // おつりアドレスの切り替え
                    await store.dispatch('accountModule/updateCurrencyAccountProperty', {
                        account: accountData,
                        property: ['changePrivIdx', 'changeAddress']
                    }, {root: true});
                }

                const urlSend = 'https://api.bitcore.io/api/BTC/' + constant.blockchainHost.Bitcoin + '/tx/send';
                axios.post(urlSend, {"rawTx": serialized})
                .then(async (response: any) => {
                    console.log('送金結果:', response.data);
                    if (response.data.txid) {
                        const now = Date.now();
                        console.log(now);
                        const unconfirmedTxHistory: unconfirmedTxHistory = {
                            name: name,
                            txid: response.data.txid,
                            amount: amount.toNumber(),
                            fees: fees,
                            change: changeAmount,
                            from: '',
                            createdAt: now
                        }
                        console.log('unconfirmedTxHistory', unconfirmedTxHistory)
                        await store.dispatch('idbPut', {
                            stateName: null,
                            storeName: 'unconfirmedTx',
                            data: unconfirmedTxHistory
                        }, {root: true});

                        resolve(true);
                    } else {
                        throw Error('no tx');
                    }

                })
                .catch((e: any) => {
                    console.error('reject', e);
                    reject({name: '送金に失敗しました。', message: e})
                });
            } catch (e) {
                reject({name: '送金に失敗しました。', message: e})
            }

        })
    },

    transferEthereum(store: any, data: any) {
        return new Promise(async (resolve, reject) => {
            try {
                /**
                 * パラメータ生成
                 */
                let parameter: any = {}
                let info = null;
                console.log('platform check', data.platform);
                switch (data.platform) {
                    case 'Ether':
                        console.log('txBefore', data);
                        // parameter.from = data.from;
                        parameter.to = data.to;
                        parameter.gasPrice = web3.utils.toHex(data.gasPrice);
                        parameter.gasLimit = web3.utils.toHex(data.gasLimit);
                        parameter.nonce = web3.utils.toHex(data.nonce);

                        // value 指定
                        const sendWei = web3.utils.toWei(data.amount, 'ether');
                        console.log('sendWei', sendWei);
                        parameter.value = web3.utils.toHex(sendWei);

                        break;
                    case 'ERC20':
                        // parameter.from = data.from;
                        parameter.to = data.to;
                        parameter.gasPrice = web3.utils.toHex(data.gasPrice);
                        parameter.gasLimit = web3.utils.toHex(data.gasLimit);
                        parameter.nonce = web3.utils.toHex(data.nonce);
                        if (data.value > 0) parameter.value = web3.utils.toHex(data.value);
                        parameter.data = data.data;
                        break;
                    default:
                        break;
                }
                console.log('parameter ready', parameter);

                if (data.platform == 'ERC20' && data.data == null) {
                    console.error('no token transfer data ', parameter);
                    throw new Error('no data');
                }
                /**
                 * 署名
                 */
                const transaction = new Tx(parameter, {chain: constant.blockchainEnvName.Ethereum});
                console.log('pkey to buffer', '"' + data.privateKey + '"');
                const privateKey = Buffer.from(data.privateKey, 'hex');

                // 秘密鍵に0xがあるとエラーになる
                console.log('tx sign', privateKey);
                transaction.sign(privateKey);
                console.log('tx signed', privateKey);

                /**
                 * 送金
                 */
                // ここでは0xが必要
                web3.eth.sendSignedTransaction('0x' + transaction.serialize().toString('hex'))
                .once('transactionHash', async (hash: any) => {
                    console.log('transactionHash', 'https://etherscan.io/tx/' + hash)
                    const now = Date.now();
                    console.log(now);
                    const unconfirmedTxHistory: unconfirmedTxHistory = {
                        name: data.name,
                        txid: hash,
                        amount: data.amount,
                        fees: data.gasPrice * data.gasLimit, //wei
                        change: 0,
                        from: data.from,
                        createdAt: now
                    }
                    console.log('unconfirmedTxHistory', unconfirmedTxHistory)
                    await store.dispatch('idbPut', {
                        stateName: null,
                        storeName: 'unconfirmedTx',
                        data: unconfirmedTxHistory
                    }, {root: true});
                })
                .once('receipt', (receipt: any) => {
                    console.log('receipt', receipt)
                })
                // .on('confirmation', (confirmationNumber: number, receipt: any) => {
                //     console.log('confirmation', confirmationNumber, receipt);
                //     if (confirmationNumber == 9) {
                //         return;
                //     }
                // })
                .on('error', (e: any) => {
                    console.log('error' + e)
                    reject({name: '送金に失敗しました', message: e});
                });
                resolve(true);
            } catch (e) {
                reject({name: '送金に失敗しました', message: e})
            }
        });
    },
    transferRipple(store: any, data: any) {
        return new Promise(async(resolve, reject) => {
            try {
                const currencyData: currencyData = await store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: data.name}, {root: true})

                const instructions = {
                    maxLedgerVersionOffset: 5,
                    fee: data.fees
                }

                let payment: any = {
                    source: {
                        address: currencyData.address,
                        maxAmount: {
                            value: String(BigNumber(data.amount).plus(data.fees).toNumber()),
                            currency: currencyData.symbol
                        }
                    },
                    destination: {
                        address: data.to,
                        amount: {
                            value: String(data.amount),
                            currency: currencyData.symbol
                        }
                    }
                };
                if (data.tag != '') {
                    payment.destination.tag = parseInt(data.tag);
                }
                const api = new RippleAPI({
                    server: rippleHost
                });
                api.connect()
                .then(() => {
                    console.log('Connected...')
                    api.preparePayment(currencyData.address, payment, instructions)
                        .then(async (prepared: any) => {
                            function bytesToHex(a: any) {
                                return a.map((byteValue: any) => {
                                    const hex = byteValue.toString(16).toUpperCase();
                                    return hex.length > 1 ? hex : `0${hex}`;
                                }).join('');
                            }

                            const privateKey = await store.dispatch('accountModule/decryptWithPin', {
                                encrypted: currencyData.privateKey,
                                pin: data.pin
                            }, {root: true});
                            const publicKey = bytesToHex(Secp256k1.keyFromPrivate(privateKey.slice(2)).getPublic().encodeCompressed());
                            const keyPair = {privateKey: privateKey, publicKey: publicKey};
                            console.log('keyPair', keyPair);
                            console.log('prepared.txJSON', prepared.txJSON);
                            const {signedTransaction, id} = await api.sign(prepared.txJSON, keyPair);
                            console.log(id)
                            return api.submit(signedTransaction);
                        })
                        .then(async (response: any) => {
                            console.log('obj', response)
                            console.log('json', JSON.stringify(response, null, 2))
                            if (response.resultCode != 'tesSUCCESS') {
                                throw Error(response.resultCode);
                            }
                            await api.disconnect();
                            resolve(true);
                        })
                        .catch(async (e: any) => {
                            console.error(e);
                            await api.disconnect()
                            reject({name: '送金に失敗しました', message: e});
                        });
                })
                .catch(async (e: any) => {
                    console.error(e);
                    reject({name: '送金に失敗しました', message: 'Rippleサーバーへのコネクションを確立できませんでした。'});
                });
            } catch (e) {
                console.error(e);
                reject({name: '送金に失敗しました', message: e});
            }
        });
    }

}

const mutations = {
    transferReady(state: any, payload: any) {
        state.transferReady = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
